import { useFetch } from "../useFetch";
import type {
	QuotationResponse,
	CreateQuotationPayload,
	CreateQuotationItemPayload,
	AddQuotationItemsPayload,
	RejectQuotationPayload,
} from "../../core/types/services";

// ============================================
// GET QUOTATION BY ID
// ============================================
export function useQuotation(id: number) {
	return useFetch<QuotationResponse>({
		endpoint: `/quotations/${id}`,
		method: "GET",
	});
}

// ============================================
// GET QUOTATION WITH ITEMS (Parece redundante si el GET normal ya trae items)
// ============================================
// Si tu backend tiene endpoints separados, úsalo. Si el GET normal trae todo, este sobra.
export function useQuotationWithItems(id: number) {
	return useFetch<QuotationResponse>({
		endpoint: `/quotations/${id}/items`, // ¿Este endpoint existe o es el mismo?
		method: "GET",
	});
}

// ============================================
// GET QUOTATIONS BY PROVIDER
// ============================================
export function useQuotationsByProvider(providerId: number) {
	// Asumimos que devuelve un array
	return useFetch<QuotationResponse[]>({
		endpoint: `/quotations/provider/${providerId}`,
		method: "GET",
	});
}

// ============================================
// CREATE QUOTATION
// ============================================
export function useCreateQuotation() {
	const fetch = useFetch<QuotationResponse, CreateQuotationPayload>({
		endpoint: "/quotations",
		method: "POST",
		auto: false,
	});

	const create = (data: CreateQuotationPayload) => {
		return fetch.execute({ body: data });
	};

	return { ...fetch, create };
}

// ============================================
// ADD ITEMS TO QUOTATION
// ============================================
export function useAddQuotationItems(quotationId: number) {
	const fetch = useFetch<QuotationResponse, AddQuotationItemsPayload>({
		endpoint: `/quotations/${quotationId}/items`,
		method: "POST",
		auto: false,
	});

	const addItems = (items: CreateQuotationItemPayload[]) => {
		return fetch.execute({ body: { items } });
	};

	return { ...fetch, addItems };
}

// ============================================
// REJECT QUOTATION
// ============================================
export function useRejectQuotation(id: number) {
	const fetch = useFetch<QuotationResponse, RejectQuotationPayload>({
		endpoint: `/quotations/${id}/reject`,
		method: "PATCH",
		auto: false,
	});

	const reject = (reason: string) => {
		return fetch.execute({ body: { reason } });
	};

	return { ...fetch, reject };
}

// ============================================
// ACCEPT QUOTATION
// ============================================
export function useAcceptQuotation(id: number) {
	// Aceptar suele no requerir body, solo el cambio de estado
	const fetch = useFetch<QuotationResponse>({
		endpoint: `/quotations/${id}/accept`,
		method: "PATCH",
		auto: false,
	});

	const accept = () => {
		return fetch.execute();
	};

	return { ...fetch, accept };
}
